import { Filter } from "./../types/filter.type";
export interface Pagination<T> {
  data: T[];
  totalRows: number;
  currentPage: number;
  rowPerPage: number;
  offset: number;
}

export interface PaginationScroll<T> {
  data: T[];
  totalRows: number;
}

export interface PaginationRequest<F = Filter> {
  page?: number;
  size?: number;
  filter?: F;
}

export const paginationOptions = [10, 20, 50, 100];

export const paginationResultDefault = {
  currentPage: 1,
  rowPerPage: paginationOptions[0],
  offset: 0,
  totalRows: 0,
  data: [],
};
